import Vue from 'vue'
import VueRouter from 'vue-router'
import LandingPage from '../pages/LandingPage.vue'
import Contactanos from '../pages/Contactanos'
import Indicadores from '../pages/Indicadores'
import Edig from '../pages/Edig'
import RestaurarPass from '../pages/restaurarPass.vue'
import InfoUsuarioVapp from '../pages/InfoUsuarioVapp.vue'


Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: LandingPage
  },
  {
    path: '/contactanos',
    name: 'Contactanos',
    component: Contactanos
  },
  {
    path: '/indicadores',
    name: 'Indicadores',
    component: Indicadores
  },
  {
    path: '/edig',
    name: 'Edig',
    component: Edig
  },
  {
    path: '/restaurarPass',
    name: 'RestaurarPass',
    component: RestaurarPass
  },
  {
    path: '/cambiarPsw',
    name: 'CambiarPsw',
    component: RestaurarPass
  },
  {
    path: '/infoUsuarioVapp',
    name: 'infoUsuarioVapp',
    component: InfoUsuarioVapp
  },

]

const router = new VueRouter({
  mode: 'hash',
  linkActiveClass: 'active',
  base: process.env.BASE_URL,
  routes
})

export default router
